import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../Common/LoadingSpinner';
import './Layout.css';

const Layout = ({ children }) => {
  const { adminUser, logout, isAuthenticated, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const menuItems = [
    { path: '/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/bookkeepers', label: 'Bookkeepers', icon: '👥' },
    { path: '/zipcodes', label: 'Zip Codes', icon: '📍' },
    { path: '/pending', label: 'Pending Approvals', icon: '⏳' },
    { path: '/expiration', label: 'Expiration', icon: '⏰' },
    { path: '/analytics', label: 'Analytics', icon: '📈' },
    { path: '/admin-users', label: 'Admin Users', icon: '👨‍💼' },
  ];

  // Authentication check and redirection
  useEffect(() => {
    // console.log('Layout - Auth check:', { 
    //   isAuthenticated, 
    //   loading, 
    //   pathname: location.pathname,
    //   isLoginPage: location.pathname === '/login'
    // });

    if (!loading && !isAuthenticated && location.pathname !== '/login') {
      // console.log('Redirecting to login from:', location.pathname);
      navigate('/login');
    }
  }, [isAuthenticated, loading, location.pathname, navigate]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Show loading spinner while checking authentication
  if (loading && location.pathname !== '/login') {
    return (
      <div className="layout-loading">
        <LoadingSpinner />
        <p>Loading...</p>
      </div>
    );
  }

  // Don't show layout for login page
  if (location.pathname === '/login') {
    return children;
  }

  // Don't show layout if not authenticated (will redirect)
  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="layout">
      {/* Sidebar */}
      <div className={`sidebar ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-header">
          <h2>ebookkeepings</h2>
          <span className="user-role">{adminUser?.role}</span>
        </div>
        
        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? 'nav-item-active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}
        </nav>
        
        <div className="sidebar-footer">
          <div className="user-info">
            <div className="username">{adminUser?.username}</div>
            <div className="user-email">{adminUser?.email}</div>
          </div>
          <button 
            className="logout-btn"
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="layout-content">
        <header className="layout-header">
          <button 
            className="sidebar-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            ☰
          </button>
          <h1 className="page-title">
            {menuItems.find(item => item.path === location.pathname)?.label || 'Dashboard'}
          </h1>
        </header>

        <main className="main-content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;